export const HEADER = {
    NOT_REQUIRED: 'Not Required',
    NOTIFICATION: 'Notification',
    GRADE_NOT_AVAILABLE: 'Grade Not Available',
    CAUTION: 'Caution',
    MAZE_SCORE: 'Maze Score',
    CP_SCORE: 'Cual palabra score',
    NO_DETAILS_AVAILABLE: 'No Details Available',
    REVIEW_UNOFFICIAL_RESULTS: 'Review Unofficial Results',
    G5_ORF_PM1_ALT_TEXT: 'ORF Grade 5 PM Form 1 Alternative Text',
};

export const BUTTONS_TEXT = {
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    OK: 'OK',
    GO_TO_MEASURE: 'Go to measure',
    REVIEW: 'Review',
    PRINTED_KIT: 'Printed Kit',
    DOWNLOADED_PDF: 'Downloaded PDF',
};

export const POPUP_NAMES = {
    DISCONTINUED: 'discontinued',
    TESTED_OUT: 'tested-out',
    GRADE_NOT_AVAILABLE: 'grade-not-available',
    GRADE_NOT_AVAILABLE_SPANISH: 'grade-not-available-spanish',
    OPTIONAL_ASSESS: 'optional-assess',
    MAZE_SCORE: 'maze-score',
    CP_SCORE: 'comprension-lectora',
    AI_NO_DETAILS_AVAILABLE_POPUP: 'ai-no-details-available-popup',
    LECTURA_NO_DETAILS_AVAILABLE_POPUP: 'lectura-no-details-available-popup',
    NO_RESULT_DETAILS_POPUP: 'no-result-details-popup',
    NO_DETAILS_AVAILABLE_POPUP: 'no-details-available-popup',
    UNOFFICIAL_RESULT_POPUP: 'unofficial-result-popup',
    TRC_OUTSIDE_BM_POPUP: 'trc-out-side-bm',
    G5_ORF_PM_FORM1_ALT_TEXT_POPUP: 'g5-orf-pm-form1-alt-text-popup',
    NO_IDEL_SUPPORT_POPUP: 'no-idel-support-popup',
};

export const POPUP_SETTINGS = 'userPopupsSettings';

export const ALT_FORM_MESSAGE = [
    'The Benchmark form has already been used for',
    'an invalidated assessment. Would you like to:',
];
